import { createFileRoute } from '@tanstack/react-router';
import { CmsPageRenderer } from '@pages/cms-page';

/** Catch-all Route für dynamische CMS-Seiten (/$slug). */
export const Route = createFileRoute('/$slug')({ component: CmsSlugPage });

function CmsSlugPage() {
  const { slug } = Route.useParams();
  return <CmsPageRenderer slug={slug} />;
}
